
import React from 'react';
import { CircleCheck, XCircle, Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { 
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';
import { BillingHistoryItem } from './billing/types';

interface PaymentHistoryProps {
  billingHistory: BillingHistoryItem[];
}

const PaymentHistory = ({ billingHistory }: PaymentHistoryProps) => {
  const getStatusIcon = (status: string) => {
    switch(status) {
      case 'Processed':
        return <CircleCheck className="inline-block mr-1 h-3 w-3" />;
      case 'Failed':
        return <XCircle className="inline-block mr-1 h-3 w-3" />;
      case 'Processing':
        return <Clock className="inline-block mr-1 h-3 w-3" />;
      default:
        return null;
    }
  };

  return (
    <Card className="border border-gray-100 rounded-lg shadow-sm w-full">
      <div className="bg-gray-50 px-6 py-4 border-b border-gray-100">
        <h3 className="text-base font-medium text-gray-800">Payment History</h3>
      </div>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow className="bg-gray-50 hover:bg-gray-50">
              <TableHead className="text-xs font-medium">Date</TableHead>
              <TableHead className="text-xs font-medium">Amount</TableHead>
              <TableHead className="text-xs font-medium">Status</TableHead>
              <TableHead className="text-xs font-medium">Card</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {billingHistory.map((item, index) => (
              <TableRow key={index} className="border-t border-gray-100 hover:bg-gray-50/50">
                <TableCell className="text-sm py-4">{item.date}</TableCell>
                <TableCell className="text-sm font-medium">{item.amount}</TableCell>
                <TableCell>
                  <span 
                    className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                      item.status === 'Processed' ? 'bg-green-100 text-green-800' : 
                      item.status === 'Failed' ? 'bg-red-100 text-red-800' : 
                      'bg-blue-100 text-blue-800'
                    }`}
                  >
                    {getStatusIcon(item.status)}
                    {item.status}
                  </span>
                </TableCell>
                <TableCell className="text-sm">{item.card}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default PaymentHistory;
